import React, { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import {
    PageWrapper,
    Flex,
    Button,
    H1WithBack,
    Table,
    Th,
    Tr,
} from 'styling/GlobalStyles'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { Td } from 'components/Td/Td'
import { dietaryPreferences } from '../foodData'
import { days } from 'pages/Employees/employeesData'
import { AddSelectedDishModal, ISelectedDish } from './AddSelectedDishModal'
import { clearSelectedDishes, getSelectedDishes } from 'features/food/foodSlice'
import { IGetSelectedDishesReponse } from 'types/api/foodApi.interface'

export const SelectedDishes = () => {
    const { selectedDishes } = useSelector((store: RootState) => store.food)
    const [modal, setModal] = useState(false)

    const transformDataForModal = (dishes: IGetSelectedDishesReponse): ISelectedDish[] => {
        return dishes.dishes.map(d => ({
            id: d.id,
            day: days.find(day => day.value == d.dayInWeek),
            dietaryPreference: dietaryPreferences.find(p => p.value == d.dietaryPreferenceType),
            mealType: { value: d.mealType.id, label: d.mealType.name },
            dish: { value: d.dish.id, label: d.dish.name },
            supplier: { value: d.supplier.id, label: d.supplier.name },
        }))
    }

    // id: number
    // day: ISelectValue
    // dietaryPreference: ISelectValue
    // mealType: ISelectValue
    // dish: ISelectValue
    // supplier: ISelectValue

    useQueryPagination({ fetchFunctions: [getSelectedDishes], cleanUpFunctions: [clearSelectedDishes], params: null })

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center>
                    <H1WithBack title='Selected Dishes' arrow />
                    <Button orange onClick={() => setModal(true)}>
                        Add Dish
                    </Button>
                </Flex>
                {!selectedDishes?.dishes?.length ? (
                    <NoItems marginTop='1rem' title='Dishes' />
                ) : (
                    <Table width='100%' >
                        <Th next>
                            <Td w='20%' noTooltip text='Day' />
                            <Td w='20%' noTooltip text='Meal Type' />
                            <Td w='20%' noTooltip text='Dish' />
                            <Td w='20%' noTooltip text='Supplier' />
                            <Td w='20%' noTooltip text='Dietary Preference' />
                        </Th>
                        {selectedDishes?.dishes?.map((item) => {
                            return (
                                <Tr key={item.id}>
                                    <Td w='20%' text={days.find(d => d.value == item.dayInWeek).label} />
                                    <Td w='20%' text={item.mealType?.name} />
                                    <Td w='20%' text={item.dish?.name} />
                                    <Td w='20%' text={item.supplier?.name} />
                                    <Td w='20%' text={dietaryPreferences.find(p => p.value == item.dietaryPreferenceType).label} />

                                </Tr>
                            )
                        })}
                    </Table>
                )}
                {modal && <AddSelectedDishModal data={transformDataForModal(selectedDishes)} closeModal={() => setModal(false)} />}
            </PageWrapper>

        </>
    )
}
